<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between pb-3>
      <h2>{{ title }}</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout row wrap align-start justify-space-between>
        <v-flex xs6>
          <v-select
            label="Position/Name"
            :items="listItems"
            v-model="formData.name"
            hide-details
          />
        </v-flex>
        <v-flex xs6 pl-2>
            <v-text-field
              v-if="['desktop.image', 'tablet.image'].includes(formData.name)"
              prepend-icon="attach_file"
              single-line
              hide-details
              v-model="formData.value"
              label="Choose Image"
              required
              class="min-w"
              @click="startInput('imageInput')"
              ref="fileTextField" />
            <input v-if="['desktop.image', 'tablet.image'].includes(formData.name)" style="display: none;" type="file" accept="image/*" ref="imageInput" @change="onFileChange('imageInput', $event)">
            <v-text-field
              v-else
              v-model="formData.value"
              label="Selected coordinate value"
              type="number"
            />
        </v-flex>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitHtmlCode()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: "PropertiesModal",
    props: ['htmlCode', 'isHtmlEdit', 'htmlKeysListFiltered', 'title'],
    data: () => ({
      listItems: [],
      formData: {
        name: '',
        value: '',
      },
      err: '',
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      getFormData(files) {
        return new Promise((resolve) => {
          let reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = function () {
            resolve(reader.result);
          };
          reader.onerror = function (error) {
            resolve(null);
          };
        });
      },
      startInput(name) {
        this.$refs[name].click();
      },
      async onFileChange(name, $event) {
        const files = $event.target.files || $event.dataTransfer.files
        if (files && files[0]) {
          const data = await this.getFormData(files);
          if (data === null) {
            this.err = 'Failed to convert image';
            return;
          }
          const maxSize = 786432;
          if (files[0].size > maxSize) {
            this.err = `The selected images is beyond limit of ${maxSize} KB.`
            this.formData.value = '';
            return;
          }
          const img = new Image();
          img.src = window.URL.createObjectURL(files[0]);
          img.onload = () => {
            window.URL.revokeObjectURL( img.src );
            this.formData.value = data;
          };
        } else {
          this.formData.value = '';
        }
      },
      submitHtmlCode() {
        if (this.formData.name === '') {
          this.err = 'You must select Position/Name!';
          return
        }
        if (this.formData.value === '') {
          this.err = 'Value cannot be empty!';
          return;
        }
        this.$emit('submit', this.formData);
      },
    },
    created() {
      this.listItems = this.htmlKeysListFiltered;
      if (this.htmlCode) {
        this.formData = this.htmlCode;
        this.listItems = [this.htmlCode.name];
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PropertiesModal.vue?afe4366e